module.exports = __webpack_public_path__ + "static/media/img-background2.5c5763ba.jpg";